import React from 'react';
import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsHeader from '@cybs-ui/components/lib/page-header';
import AuthenticationCard from './authentication-card';
import HeaderCard from './header-card';
import '../../css/api-endpoints.css';
import { useSelector } from 'react-redux';
import { isDefaultSite } from '../../../commons/ui-commons.js';
import { getPartnerFullName} from '../../../lhs/reducers/configuration-reducer.js';

const StaticApiEndpointsSection = () => {
    var apiProdURL = useSelector(state => state.configurationReducer.apiProdURL);
    var apiHostURL = useSelector(state => state.configurationReducer.apiHostURL);
    var partnerFullName = getPartnerFullName();

    if(isDefaultSite()){
      partnerFullName = partnerFullName.trim().length > 0 ? partnerFullName : 'Cybersource';
    }
      
    if (apiProdURL != undefined && apiHostURL != undefined) {
        return (<React.Fragment>
          <div>
            <CybsHeader
              breadCrumbs={[
                {
                  pageTitle: 'API Endpoints and Authentication'
                }
              ]}
              i18n={{
                ariaLabel: 'Navigation List',
                title: 'Details'
              }}
              dataTest="header-basic"
            />
            <div style={{ marginBottom: '50px', width: '100%' }}>
              <div style={{ marginBottom: '50px', margin: "2% 1% 0.5%", display: 'flex' }}>
                <div style={{ marginRight: '4px', width: "40%" }}>
                  <CybsCard
                    style={{ height: '100%' }}
                    header={
                      <CybsActionBar
                        i18n={{ title: "Endpoints" }}
                        dataTest="payment-info-with-button"
                      />
                    }
                  >
                    <p>All requests to the {partnerFullName} REST API are sent via the HTTP to one of our API endpoint URLs</p>
                    <p>Sandbox API Endpoint:<br/>{"https://" + apiHostURL}</p>
                    <p>Production API Endpoint:<br/>{"https://" + apiProdURL}</p>

                  </CybsCard>
                </div>
                  <div className='headersCard'>
                      <HeaderCard />
                  </div>
              </div>
              <AuthenticationCard src="Endpoint" />
            </div>
          </div>
        </React.Fragment>)
      }
      else {
        return (
          <span></span>
        )
      }
};

StaticApiEndpointsSection.displayName = 'StaticApiEndpointsSection';

export default StaticApiEndpointsSection;


